// libraries
import {combineReducers} from 'redux';
import {reducer as formReducer} from 'redux-form';

// auth
import {
  RECEIVE_COUNTRIES,
  RECEIVE_CITIES,
  RECEIVE_SCHOOLS
} from '../eligibility/actions/eligibility';

import {
  RECEIVE_URL_PARAMETERS
} from '../shared/actions/url-parameters';

// shared
import {notificationsReducer} from 'shared/reducers/notifications';
import {genericReducer} from 'shared/reducers/generic-reducer';
import {accessibilityAnnouncementReducer} from 'shared/reducers/accessibility-announcement';

export default combineReducers({
  accessibilityAnnouncement: accessibilityAnnouncementReducer,
  cities: genericReducer({actionProperty: 'cities', defaultState: {}, setAction: RECEIVE_CITIES}),
  countries: genericReducer({actionProperty: 'countries', defaultState: [], setAction: RECEIVE_COUNTRIES}),
  form: formReducer,
  notifications: notificationsReducer,
  schools: genericReducer({actionProperty: 'schools', defaultState: [], setAction: RECEIVE_SCHOOLS}),
  urlParameters: genericReducer({actionProperty: 'params', defaultState: '', setAction: RECEIVE_URL_PARAMETERS})
});
